import React, { useCallback } from "react";
import styles from "./Style.module.css";
import achievedIcon from "../../../../../assets/img/ic_achieved.png"; // Replace with actual icons
import targetIcon from "../../../../../assets/img/ic_targets.png";
import clockIcon from "../../../../../assets/img/ic_last_updated.png";
import ypm from "../../../../../assets/img/ic_ypm_ratio.png";
import ps from "../../../../../assets/img/ic_ps_ratio.png";
import noDataImage from "../../../../../assets/img/ic_no_data_available.png";
import { Doughnut } from "react-chartjs-2";
import { getBackgroundColor } from "../../../../../helper/helper";
import history from "../../../../../libs/history.utils";
import RouteName from "../../../../../routes/Route.name";

const ZoneStatus = ({ zoneData }) => {
  const options = {
    responsive: false,
    cutout: "90%",
    cutoutPercentage: 80,
    rotation: 1 * Math.PI,
    circumference: 1 * Math.PI,
    legend: {
      display: false,
    },
    tooltips: {
      enabled: true,
      callbacks: {
        label: (tooltipItem) => {
          const actualValue = zoneData?.sales_data?.achieved_pct;
          const index = tooltipItem.index;
          if (index === 0) {
            return `Achieved: ${actualValue} %`;
          } else {
            const remainingValue = Math.max(0, 100 - actualValue);
            return `Remaining: ${remainingValue?.toFixed(2)} %`;
          }
        },
      },
    },
    elements: {
      arc: {
        borderWidth: 0.5,
        cornerRadius: 10,
        borderSkipped: (ctx) => (ctx.raw.angle > Math.PI ? 20 : 0),
      },
    },
  };

  const data = {
    labels: ["Achieved", "Remaining"],
    datasets: [
      {
        data: [
          Math.min(zoneData?.sales_data?.achieved_pct, 100),
          Number(Math.max(0, 100 - zoneData?.sales_data?.achieved_pct).toFixed(2))
        ],
        backgroundColor: [
          getBackgroundColor(zoneData?.sales_data?.achieved_pct),
        ],
        borderColor: [],
        borderWidth: 0.5,
        hoverOffset: 4,
        cutout: "90%",
      },
    ],
  };
  return (
    <div className={styles.container}>
      <div className={styles.quaterWrap}>
        <div>
          <span className={styles.title}>{zoneData?.name}</span>

          <div className={styles.newLine} />
        </div>
      </div>

      <div className={`${styles.statusContainer}`}>
        <div className={`${styles.containerInner}`}>
          <Doughnut data={data} options={options} height={"100px"} />

          <div className={`${styles.divContainer}`}>
            {zoneData?.sales_data?.achieved_pct ? (
              <>
                <div className={styles.title21}>
                  {zoneData?.sales_data?.achieved_pct} %
                </div>
                <div className={styles.title}>{"Achieved percentage"}</div>
              </>
            ) : (
              <div>
                <img src={noDataImage} className={styles.noImg} />
              </div>
            )}
          </div>
        </div>
        <div className={styles.cardWrapper}>
          <div className={styles.InnerCard}>
            <div className={styles.card}>
              <img src={targetIcon} alt="Target" className={styles.icon} />
              <div className={styles.desWrap}>
                <span className={styles.number}>
                  ₹ {zoneData?.sales_data?.target || "N/A"}
                </span>
                <span className={styles.text}>Target</span>
              </div>
            </div>
            <>
              <div className={styles.card}>
                <img
                  src={achievedIcon}
                  alt="Achieved"
                  className={styles.icon}
                />
                <div className={styles.desWrap}>
                  <span className={styles.number} style={{ color: "#00C49F" }}>
                    ₹ {zoneData?.sales_data?.achieved || "N/A"}
                  </span>
                  <span className={styles.text}>Primary Achieved</span>
                </div>
              </div>

              <div className={styles.cardSecond}>
                <div className={styles.desWrap21}>
                  <span className={styles.number}>
                    {zoneData?.sales_data?.sec_achieved ?? "N/A"}
                  </span>
                  <span className={styles.text}>Secondary Achieved</span>
                </div>
              </div>
              <div className={styles.card}>
                <img src={ps} alt="Last Updated" className={styles.icon} />
                <div className={styles.desWrap}>
                  <span className={styles.number}>
                    {zoneData?.sales_data?.p_s_ratio ?? "N/A"}
                  </span>
                  <span className={styles.text}>P/S Ratio</span>
                </div>
              </div>
            </>
          </div>
          <div className={styles.InnerCard}>
            <div className={styles.card}>
              <img src={ypm} alt="Achieved" className={styles.icon} />
              <div className={styles.desWrap}>
                <span className={styles.number} style={{ color: "#00C49F" }}>
                  ₹ {zoneData?.sales_data?.ypm || "N/A"}
                </span>
                <span className={styles.text}>YPM</span>
              </div>
            </div>

            <div className={styles.card}>
              <img src={clockIcon} alt="Target" className={styles.icon} />
              <div className={styles.desWrap}>
                <a
                  target="_blank"
                  href={RouteName?.EMPLOYEE_DETAIL + zoneData?.head?.code}
                  style={{textDecoration:"none"}}
                >
                  <span
                    className={styles.number21}
                  >
                    <b>{zoneData?.head?.name}</b> ( {zoneData?.head?.code} )
                  </span>
                </a>
                <span className={styles.text}>HOD</span>
              </div>
            </div>
            <div className={styles.cardSecond}></div>
            <div className={styles.card}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ZoneStatus;
